import React from 'react';
import Card from './components/Card'
import './App.css'


export default function App () {
  return (
      <div className='container'>
        <Card />
      </div>
  )
}
